import moment from 'moment';


export default ({dateTime}) => {
    
    return moment(dateTime).locale('th').format('DD MMM YYYY - HH:mm');
}